import axios from 'axios';
import { afficherDialogueAuthentication } from '@mfa/commun-react';

export async function getAxios(url) {
    let config = {
        cache: 'no-store',
    }
    const promise = axios.get(url, config)
        .catch(error => {
            afficherDialogueAuthentication(error.response);
        })
    const dataPromise = promise.then((response) => (response == null ? [] : response.data))
    return dataPromise;
}

export async function delAxios(url, contexte) {
    let config = {
        headers: {
            Authentication: contexte.contexteSAI,
        }
    }
    return axios.delete(url, config)
        .then(() => true)
        .catch(error => {
            afficherDialogueAuthentication(error.response, contexte);
        })
}

export async function putAxios(url, contexte) {
    let config = {
        headers: {
            Authentication: contexte.contexteSAI,
        }
    }
    return axios.put(url, config)
        .then(() => true)
        .catch(error => {
            afficherDialogueAuthentication(error.response, contexte);
        })
}

export async function postAxiosFile(url, fichier, contexte) {

    const config = {
        headers: {
            Authentication: contexte.contexteSAI,
            contentType: 'application/pdf',
            'Content-Type': 'multipart/form-data',
        }
    }

    return axios.post(url, fichier, config)
        .then(() => true)
        .catch(error => {
            afficherDialogueAuthentication(error.response, contexte);
        });
}

axios.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response;
}, error => {
    return Promise.reject(error);
});

